import React from "react"
import { HomeHeroWrapper } from "./HomeHero.styles"
import ArrowRight from "../../../icons/phosphor/regular/ArrowRight"
import { graphql, useStaticQuery } from "gatsby"
import VideoEmbed from "../../Flexipage/Global/VideoEmbed/VideoEmbed"

/**
 * @returns {{
 *   title: string
 *   video: string | null
 * }|null}
 */
function useHomeHero(){
  const query = useStaticQuery(graphql`
    query HomeHeroQuery {
      statamic {
        entries(collection: "home", limit: 1) {
          data {
            ... on Statamic_Entry_Home_Home {
              title
              video_url
            }
          }
        }
      }
    }
  `)

  const node = query?.statamic?.entries?.data?.[0]
  if(!node) return null

  return {
    title: node.title,
    video: node.video_url || null,
  }
}

export default function HomeHero(){
  const homeHero = useHomeHero()
  if(!homeHero) return null
  return (
      <HomeHeroWrapper className="px-3">
        <div className="container">
          <h1>{homeHero.title}</h1>

          <div className="buttons">
            <a href="/contact-us" className="btn">Request a demo</a>
            <a href="/payment-orchestration-platform/" className="btn ghost">
              See how it works
              <ArrowRight />
            </a>
          </div>

          {homeHero.video && <div className="animation-wrapper">
            <div className="animation">
              <VideoEmbed url={homeHero.video} defaultStyles={false} />
            </div>
          </div>}
        </div>
      </HomeHeroWrapper>
  )
}
